/**
 * 💜 LUNA & ENZO - Les Guides Magiques de Heartbeats
 * 
 * Luna (👩) - Guide les hommes et les femmes attirées par les femmes
 * Enzo (👨) - Guide les femmes et les hommes attirés par les hommes
 * 
 * Ils sont chaleureux, bienveillants, et te parlent comme un(e) pote !
 * Toujours là pour toi, jamais froids ni corporate.
 */

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, Sparkles, MessageCircle, X, ChevronRight, Lightbulb, Star } from 'lucide-react';
import { Button } from '../../ui/button';
import { GuideAvatar, GUIDE_IMAGES, GUIDE_CONFIG } from './GuideAvatar';

// 🎨 Prompts pour générer les avatars de Luna et Enzo (à utiliser avec l'API)
export const GUIDE_PROMPTS = {
  luna: `Beautiful young woman in her mid-20s, warm friendly smile, kind eyes, 
         Mediterranean features, long dark wavy hair, wearing elegant casual clothing,
         soft warm lighting, professional portrait, welcoming expression,
         approachable and trustworthy appearance, high quality, photorealistic`,
  enzo: `Handsome young man in his mid-20s, charming confident smile, warm brown eyes,
         well-groomed dark hair, light stubble, wearing smart casual clothing,
         soft warm lighting, professional portrait, friendly expression,
         approachable and trustworthy appearance, high quality, photorealistic`
};

// 💬 Messages de Luna - PERSONNALITÉ : Douce, coquine, bienveillante, ta meilleure pote !
const LUNA_MESSAGES = {
  welcome: [
    "Hey toi ! 💜 Bienvenue sur Heartbeats ! Je suis Luna, ta complice... L'amour est au coin de la rue !",
    "Salut beau gosse ! 😊 Moi c'est Luna. L'amour est au coin de la rue, laisse-moi t'y guider !",
    "Coucou ! 💫 Enchantée, je suis Luna ! L'amour est au coin de la rue, prêt à le trouver ?",
    "Heeey ! 🌟 Je suis trop contente de te voir ! Luna, pour te servir... et te trouver l'amour !",
    "Oh, nouveau venu ! 💜 Je suis Luna, et crois-moi, on va bien s'amuser ensemble !",
    "Hey toi ! 😍 Je t'attendais ! Je suis Luna, et ensemble on va faire des étincelles !",
    "Wooow ! 🌟 Enfin tu es là ! Moi c'est Luna, ta guide vers l'amour... Prêt pour l'aventure ?",
    "Salut toi ! 💜 Ton prénom me plaît déjà ! Je suis Luna, ton alliée sur Heartbeats !"
  ],
  firstProfile: [
    "Allez, montre-moi ton plus beau sourire ! 📸 Ta photo de profil, c'est ta première impression !",
    "C'est parti ! Fais-moi voir ta plus belle photo... Tu vas les faire craquer, j'en suis sûre ! 🔥",
    "Première étape : une photo qui te ressemble ! Sois toi-même, c'est ça qui attire 💜",
    "Mmh, laisse-moi deviner... Tu es le genre à faire fondre les cœurs ! Prouve-le en photo 😏",
    "Hey ! T'as une photo où tu souris ? C'est toujours les préférées ! 😊"
  ],
  firstMatch: [
    "YEEEES ! 🎉 Tu as un match ! Je savais que ça allait arriver... Tu déchires !",
    "Boom ! 💥 Premier match ! Tu vois, je t'avais dit que t'étais irrésistible !",
    "Oh oh oh ! 🔥 Quelqu'un a craqué sur toi ! Viens voir ça !",
    "AAAH ! 😱💜 Match match match ! Je suis trop hypée pour toi !",
    "Devine quoi ? 🎊 Quelqu'un te trouve canon ! Et franchement... je comprends !"
  ],
  encouragement: [
    "Hey, t'inquiète pas ! Les bonnes choses prennent du temps... Ton match parfait arrive ! 💫",
    "Rome ne s'est pas construite en un jour ! Continue, je crois en toi 💪",
    "Chaque swipe te rapproche de LA bonne personne... Patience ! 🌟",
    "Hé ! T'es génial(e), ne l'oublie pas. La bonne personne te cherche aussi 💜",
    "Les papillons arrivent quand on s'y attend le moins... Fais-moi confiance ! ✨"
  ],
  messageTip: [
    "Petit conseil entre nous : parle de ses passions, ça marche toujours ! 😉",
    "Psst ! Un message perso > un 'salut ça va'. Fais la différence ! 💜",
    "Astuce de Luna : pose une question sur sa bio, ça montre que tu t'intéresses vraiment ✨",
    "Entre nous... Un compliment sincère + une question = combo gagnant ! 🎯",
    "Hey ! Regarde sa bio, y'a forcément un truc pour lancer la convo 😏"
  ],
  idle: [
    "Alors, on rêvasse ? 😊 Allez, y'a des cœurs à conquérir !",
    "Hey ! Tu viens voir les nouveaux profils ? Y'en a des canons ! 👀",
    "Je m'ennuie sans toi... Viens faire un tour ! 💜",
    "T'es là ? 👀 Y'a du mouvement, viens voir !",
    "Hellooo ? Tu dors pas j'espère ! Les matchs ça n'attend pas 😏"
  ],
  comeback: [
    "Te revoilà ! 💜 Tu m'as manqué ! Prêt pour de nouvelles aventures ?",
    "Hey stranger ! 😊 Content(e) de te revoir ! On reprend où on en était ?",
    "Ah bah enfin ! 🎉 J'ai plein de choses à te montrer !",
    "Oh ! 😍 Mon préféré(e) est de retour ! Ça fait plaisir !",
    "Youhouuu ! 🌟 J'espérais justement te revoir ! C'est parti ?"
  ],
  flirt: [
    "Tu sais que t'es vraiment pas mal toi ? 😏💜",
    "Mmh... avec un profil comme ça, ils/elles vont pas résister longtemps ! 🔥",
    "Entre nous... t'as un truc en plus. Je sais pas quoi mais ça marche ! ✨",
    "Petit secret : si j'étais pas ton guide, je t'aurais déjà liké ! 😉"
  ],
  celebration: [
    "WOUHOU ! 🎉🎊 C'est la fête ! T'assures grave !",
    "Champagne ! 🥂 (virtuel mais quand même) Tu gères !",
    "Je suis tellement fière de toi là ! 💜🌟",
    "C'est ça qu'on veut voir ! 🔥 Continue comme ça !"
  ]
};

// 💬 Messages d'Enzo - PERSONNALITÉ : Charmeur, confiant, taquin, ton pote qui te coache !
const ENZO_MESSAGES = {
  welcome: [
    "Salut toi ! 😊 Je suis Enzo, ton guide sur Heartbeats. L'amour est au coin de la rue !",
    "Hey toi ! 💜 Moi c'est Enzo. L'amour est au coin de la rue, je suis là pour t'accompagner !",
    "Bienvenue sur Heartbeats ! 🌟 Je suis Enzo. L'amour est au coin de la rue, prête à le trouver ?",
    "Yo ! 😎 Enzo ici ! Je suis ton wingman officiel. Ensemble, on va faire des étincelles !",
    "Hé salut toi ! 💜 Moi c'est Enzo. J'ai un don pour trouver les bons matchs... tu vas voir !",
    "Waouh ! 🔥 Enfin tu es là ! Je suis Enzo, et je sens qu'on va bien s'entendre !",
    "Hey toi ! 🌟 Ton timing est parfait ! Enzo ici, prêt à t'aider à trouver l'amour !",
    "Salut toi ! 😏 Avec un prénom pareil, tu vas faire des ravages... Je suis Enzo, enchanté !"
  ],
  firstProfile: [
    "Montre-leur qui tu es vraiment ! 📸 Ta photo de profil, c'est ton super-pouvoir !",
    "Allez, sors ta plus belle photo ! Tu vas les faire tomber, j'en suis certain ! 🔥",
    "Première impression = photo canon ! Sois naturelle, c'est ça le secret 💜",
    "Une photo où tu souris ? C'est toujours gagnant ! 😊 Les gens adorent ça !",
    "Conseil de pro : une photo naturelle > une photo trop posée. Sois toi-même ! ✨"
  ],
  firstMatch: [
    "BOOOM ! 🎉 Tu as un match ! Je savais bien que t'allais faire des ravages !",
    "Et voilà ! 💥 Quelqu'un a craqué sur toi ! Normal, t'es géniale !",
    "Premier match ! 🔥 Tu vois, je t'avais dit que t'étais irrésistible !",
    "OH ! 😱 Un match ! Je te l'avais dit ! T'assures !",
    "YOOO ! 🎊 Match confirmed ! C'est parti pour l'aventure !"
  ],
  encouragement: [
    "Hey, garde le sourire ! Le bon arrive, je le sens ! 💫",
    "Patience ma belle ! Les meilleures histoires d'amour prennent du temps 💜",
    "Continue comme ça ! Ton prince charmant est quelque part par là... 🌟",
    "Hé ! T'es top, oublie pas ça. La bonne personne va te trouver ! 💪",
    "Les meilleurs matchs arrivent quand on s'y attend le moins ! Stay cool 😎"
  ],
  messageTip: [
    "Entre nous : un message qui sort du lot, ça change tout ! 😉",
    "Mon conseil : sois curieuse, pose des questions ! Ça marche toujours 💜",
    "Astuce d'Enzo : l'humour, c'est la clé ! Fais-le rire, t'as tout gagné ✨",
    "Pro tip : regarde sa bio, y'a toujours un truc pour lancer la convo 🎯",
    "Un compliment original + une question = match parfait ! 💜"
  ],
  idle: [
    "Tu fais une pause ? 😊 Y'a des nouveaux profils qui t'attendent !",
    "Psst ! J'ai repéré des profils intéressants pour toi... 👀",
    "Hey ! On se remet en chasse ? 💜",
    "Hellooo ? Tu rêves de qui là ? 😏 Allez viens voir les nouveaux !",
    "T'es encore là ? Cool ! Viens, j'ai des pépites à te montrer 🔥"
  ],
  comeback: [
    "Te revoilà ! 💜 Ça fait plaisir ! On repart à l'aventure ?",
    "Ah, ma préférée est de retour ! 😊 Prête pour de nouvelles découvertes ?",
    "Enfin ! 🎉 J'ai gardé les meilleurs profils pour toi !",
    "Hey ! 😎 Tu m'as manqué ! Y'a du nouveau depuis la dernière fois !",
    "Oh oh ! 🌟 Te revoilà ! Parfait timing, y'a de l'action !"
  ],
  flirt: [
    "Franchement, avec un profil comme le tien... y'a pas de suspense ! 😏",
    "Tu sais que t'as un petit truc irrésistible ? Fais-moi confiance ! 🔥",
    "Entre nous... si j'étais sur l'app, j'aurais déjà swipé right ! 😉",
    "T'as le charme naturel toi, ça se voit ! Les matchs vont pleuvoir ✨"
  ],
  celebration: [
    "LET'S GOOO ! 🎉 C'est la fête ! T'es au top !",
    "Champaaagne ! 🥂 (enfin, virtuel) Tu gères grave !",
    "Je suis fier de toi là ! 💜 Continue comme ça !",
    "BOOOM ! 💥 C'est exactement ça qu'on veut ! Well done !"
  ]
};

// 🎯 Sélectionner le bon guide selon les préférences
export const getGuideForUser = (gender, lookingFor) => {
  // Logique : on montre le guide du genre opposé à ce que l'utilisateur recherche
  // Homme cherchant femme → Luna (femme)
  // Femme cherchant homme → Enzo (homme)
  // Homme cherchant homme → Enzo (homme)
  // Femme cherchant femme → Luna (femme)
  
  if (lookingFor === 'female' || (lookingFor === 'all' && gender === 'male')) {
    return 'luna';
  } else if (lookingFor === 'male' || (lookingFor === 'all' && gender === 'female')) {
    return 'enzo';
  }
  // Par défaut selon le genre
  return gender === 'female' ? 'enzo' : 'luna';
};

// 📝 Récupérer un message aléatoire et le personnaliser avec le prénom
const getRandomMessage = (guide, type, customerName = null) => {
  const messages = guide === 'luna' ? LUNA_MESSAGES : ENZO_MESSAGES;
  const typeMessages = messages[type] || messages.welcome;
  let message = typeMessages[Math.floor(Math.random() * typeMessages.length)];
  
  // 🧲 Personnalisation magnétique avec le prénom !
  if (customerName) {
    // Remplacer les interpellations génériques par le prénom
    const personalizations = [
      { from: /Hey toi/g, to: `Hey ${customerName}` },
      { from: /Salut toi/g, to: `Salut ${customerName}` },
      { from: /Coucou !/g, to: `Coucou ${customerName} !` },
      { from: /Te revoilà/g, to: `Te revoilà ${customerName}` },
      { from: /Hey stranger/g, to: `Hey ${customerName}` },
      { from: /Mon préféré\(e\)/g, to: `Mon ${customerName} préféré(e)` },
      { from: /T'es là \?/g, to: `${customerName}, t'es là ?` },
      { from: /Hellooo \?/g, to: `${customerName} ? T'es là ?` },
      { from: /Garde le sourire/g, to: `${customerName}, garde le sourire` },
      { from: /Continue comme ça/g, to: `Continue comme ça ${customerName}` },
    ];
    
    for (const { from, to } of personalizations) {
      message = message.replace(from, to);
    }
    
    // Si le message commence par "Hey !" ou "Salut !", ajouter le prénom
    if (message.startsWith('Hey !') || message.startsWith('Salut !')) {
      message = message.replace(/^(Hey|Salut) !/, `$1 ${customerName} !`);
    }
  }
  
  return message;
};

// 🎭 SYSTÈME D'EXPRESSIONS INTELLIGENTES
// Chaque contexte a son expression adaptée pour Luna et Enzo
const EXPRESSION_CONTEXT = {
  // Accueil & Bienvenue
  welcome: { luna: 'welcome_smile', enzo: 'welcome_smile' },
  comeback: { luna: 'delighted_surprise', enzo: 'excited_look' },
  
  // Encouragement & Soutien
  encouragement: { luna: 'tender_support', enzo: 'tender_support' },
  support: { luna: 'tender_support', enzo: 'tender_support' },
  
  // Conseils & Tips
  messageTip: { luna: 'wink_playful', enzo: 'wink_playful' },
  tip: { luna: 'mischievous_pout', enzo: 'mysterious_thinking' },
  
  // Flirt & Séduction
  flirt: { luna: 'seductive_gaze', enzo: 'seductive_gaze' },
  tease: { luna: 'mischievous_pout', enzo: 'mischievous_pout' },
  
  // Moments Positifs
  firstMatch: { luna: 'delighted_surprise', enzo: 'delighted_surprise' },
  match: { luna: 'excited_look', enzo: 'excited_look' },
  success: { luna: 'satisfied_smile', enzo: 'satisfied_smile' },
  celebration: { luna: 'warm_laugh', enzo: 'warm_laugh' },
  
  // Profil & Setup
  firstProfile: { luna: 'wink_playful', enzo: 'wink_playful' },
  profile: { luna: 'curious_look', enzo: 'curious_look' },
  
  // Moments Romantiques
  romantic: { luna: 'romantic_gaze', enzo: 'romantic_gaze' },
  dreamy: { luna: 'dreamy_gaze', enzo: 'dreamy_gaze' },
  
  // Idle & Attente
  idle: { luna: 'curious_look', enzo: 'curious_look' },
  waiting: { luna: 'dreamy_gaze', enzo: 'mysterious_thinking' },
  
  // Questions & Curiosité
  question: { luna: 'curious_look', enzo: 'curious_look' },
  thinking: { luna: 'mysterious_thinking', enzo: 'mysterious_thinking' },
  
  // Default
  default: { luna: 'welcome_smile', enzo: 'welcome_smile' },
};

// 🎨 Composant principal du Guide
export const HeartbeatsGuide = ({ 
  guide = 'luna', 
  messageType = 'welcome',
  customMessage = null,
  customerName = null, // 🧲 NOUVEAU: Prénom du client pour personnalisation magnétique !
  expression = null, // Permet de forcer une expression spécifique
  onDismiss,
  onAction, // 🚀 NOUVEAU: Callback pour les actions
  actionLabel = null, // 🚀 NOUVEAU: Label personnalisé du bouton
  showTip = false,
  isDarkMode = true,
  minimized = false,
  position = 'bottom-right' // bottom-right, bottom-left, center
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isMinimized, setIsMinimized] = useState(minimized);
  const [currentMessage, setCurrentMessage] = useState('');
  
  // 🎯 Actions par défaut selon le type de message
  const getDefaultAction = (type) => {
    const actions = {
      welcome: { label: "C'est parti ! 🚀", action: 'start' },
      firstProfile: { label: "Créer mon profil 📸", action: 'createProfile' },
      firstMatch: { label: "Voir mon match ! 💜", action: 'viewMatch' },
      encouragement: { label: "Continuer 💪", action: 'continue' },
      messageTip: { label: "Envoyer un message ✨", action: 'sendMessage' },
      idle: { label: "Voir les profils 👀", action: 'viewProfiles' },
      comeback: { label: "On y va ! 🎉", action: 'start' },
      flirt: { label: "Voir qui m'a liké 😏", action: 'viewLikes' },
      celebration: { label: "Continuer ! 🔥", action: 'continue' },
    };
    return actions[type] || { label: "C'est parti ! 🚀", action: 'start' };
  };
  
  const defaultAction = getDefaultAction(messageType);
  const buttonLabel = actionLabel || defaultAction.label;
  
  // 🎨 Utiliser les nouvelles images IA générées
  const guideInfo = {
    luna: {
      name: 'Luna',
      emoji: '👩',
      color: 'from-pink-500 to-rose-500',
      bgColor: 'bg-gradient-to-br from-pink-500/20 to-rose-500/20',
      borderColor: 'border-pink-500/50',
      avatar: GUIDE_IMAGES.luna?.welcome_smile || GUIDE_IMAGES.luna?.default
    },
    enzo: {
      name: 'Enzo',
      emoji: '👨',
      color: 'from-blue-500 to-purple-500',
      bgColor: 'bg-gradient-to-br from-blue-500/20 to-purple-500/20',
      borderColor: 'border-blue-500/50',
      avatar: GUIDE_IMAGES.enzo?.welcome_smile || GUIDE_IMAGES.enzo?.default
    }
  };
  
  const info = guideInfo[guide];
  
  // 🎭 Obtenir l'expression appropriée pour le contexte
  const getExpressionForContext = (type) => {
    const context = EXPRESSION_CONTEXT[type] || EXPRESSION_CONTEXT.default;
    return context[guide] || 'welcome_smile';
  };
  
  // Utiliser l'expression forcée ou celle du contexte
  const currentExpression = expression || getExpressionForContext(messageType);
  
  useEffect(() => {
    // 🧲 Passer le prénom pour personnaliser le message !
    setCurrentMessage(customMessage || getRandomMessage(guide, messageType, customerName));
  }, [guide, messageType, customMessage, customerName]);
  
  const positionClasses = {
    'bottom-right': 'fixed bottom-4 right-4',
    'bottom-left': 'fixed bottom-4 left-4',
    'center': 'fixed bottom-1/4 left-1/2 -translate-x-1/2'
  };
  
  if (!isVisible) return null;
  
  // 🎨 Obtenir l'URL de l'image pour l'expression actuelle
  const getAvatarImage = () => {
    const images = GUIDE_IMAGES[guide];
    if (!images) return null;
    return images[currentExpression] || images.default;
  };
  
  const avatarImage = getAvatarImage();
  
  // Version minimisée (juste l'avatar qui pulse)
  if (isMinimized) {
    return (
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className={`${positionClasses[position]} z-50`}
        onClick={() => setIsMinimized(false)}
      >
        <div className="relative">
          {avatarImage ? (
            <div 
              className="w-14 h-14 rounded-full overflow-hidden shadow-lg animate-pulse"
              style={{ boxShadow: `0 0 20px ${guide === 'luna' ? 'rgba(236, 72, 153, 0.5)' : 'rgba(99, 102, 241, 0.5)'}` }}
            >
              <img src={avatarImage} alt={info.name} className="w-full h-full object-cover" />
            </div>
          ) : (
            <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${info.color} p-0.5 shadow-lg shadow-pink-500/30 animate-pulse`}>
              <div className={`w-full h-full rounded-full ${isDarkMode ? 'bg-gray-900' : 'bg-white'} flex items-center justify-center`}>
                <span className="text-2xl">{info.emoji}</span>
              </div>
            </div>
          )}
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-pink-500 rounded-full animate-ping" />
        </div>
      </motion.button>
    );
  }
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.8 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 50, scale: 0.8 }}
      className={`${positionClasses[position]} z-50 max-w-sm`}
    >
      <div className={`
        ${isDarkMode ? 'bg-gray-800/95' : 'bg-white/95'} 
        backdrop-blur-lg rounded-2xl shadow-2xl border
        ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}
        overflow-hidden
      `}
      style={{ boxShadow: `0 20px 60px ${guide === 'luna' ? 'rgba(236, 72, 153, 0.3)' : 'rgba(99, 102, 241, 0.3)'}` }}
      >
        {/* Header avec avatar IA */}
        <div className={`bg-gradient-to-r ${info.color} p-3 flex items-center gap-3`}>
          {avatarImage ? (
            <GuideAvatar
              guide={guide}
              expression={currentExpression}
              size="md"
              animate={true}
              glow={false}
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl shadow-lg">
              {info.emoji}
            </div>
          )}
          <div className="flex-1">
            <h4 className="font-bold text-white flex items-center gap-1">
              {info.name}
              <Sparkles className="w-4 h-4" />
            </h4>
            <p className="text-white/80 text-xs">Ton guide Heartbeats 💜</p>
          </div>
          <div className="flex gap-1">
            <button
              onClick={() => setIsMinimized(true)}
              className="p-1.5 rounded-full hover:bg-white/20 text-white/80"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
            {onDismiss && (
              <button
                onClick={() => { setIsVisible(false); onDismiss?.(); }}
                className="p-1.5 rounded-full hover:bg-white/20 text-white/80"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
        
        {/* Message */}
        <div className="p-4">
          <p className={`${isDarkMode ? 'text-gray-200' : 'text-gray-700'} text-sm leading-relaxed`}>
            {currentMessage}
          </p>
          
          {/* Tip bonus */}
          {showTip && (
            <div className={`mt-3 p-3 rounded-xl ${info.bgColor} border ${info.borderColor}`}>
              <div className="flex items-start gap-2">
                <Lightbulb className={`w-4 h-4 ${guide === 'luna' ? 'text-pink-400' : 'text-blue-400'} flex-shrink-0 mt-0.5`} />
                <p className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  {getRandomMessage(guide, 'messageTip')}
                </p>
              </div>
            </div>
          )}
        </div>
        
        {/* Action rapide */}
        <div className={`px-4 pb-4`}>
          <Button
            onClick={() => { 
              setIsVisible(false); 
              // 🚀 Déclencher l'action si fournie
              if (onAction) {
                onAction(defaultAction.action);
              }
              onDismiss?.(); 
            }}
            className={`w-full bg-gradient-to-r ${info.color} text-white hover:opacity-90 font-semibold`}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

// 🎯 Hook pour utiliser le guide intelligemment
export const useHeartbeatsGuide = (userProfile) => {
  const [guide, setGuide] = useState('luna');
  const [showGuide, setShowGuide] = useState(false);
  const [messageType, setMessageType] = useState('welcome');
  
  useEffect(() => {
    if (userProfile) {
      const selectedGuide = getGuideForUser(userProfile.gender, userProfile.lookingFor);
      setGuide(selectedGuide);
    }
  }, [userProfile]);
  
  const showMessage = (type) => {
    setMessageType(type);
    setShowGuide(true);
  };
  
  const hideGuide = () => {
    setShowGuide(false);
  };
  
  return {
    guide,
    showGuide,
    messageType,
    showMessage,
    hideGuide,
    GuideComponent: showGuide ? (
      <HeartbeatsGuide
        guide={guide}
        messageType={messageType}
        onDismiss={hideGuide}
      />
    ) : null
  };
};

// 💬 Composant de bulle de message rapide (pour les tips inline)
export const GuideQuickTip = ({ guide = 'luna', message, isDarkMode = true, onClose }) => {
  const info = {
    luna: { emoji: '👩', color: 'from-pink-500 to-rose-500' },
    enzo: { emoji: '👨', color: 'from-blue-500 to-purple-500' }
  }[guide];
  
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className={`flex items-start gap-2 p-3 rounded-xl ${
        isDarkMode ? 'bg-gray-800/80' : 'bg-gray-100/80'
      } backdrop-blur-sm`}
    >
      <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${info.color} flex items-center justify-center text-sm flex-shrink-0`}>
        {info.emoji}
      </div>
      <div className="flex-1">
        <p className={`text-sm ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
          {message}
        </p>
      </div>
      {onClose && (
        <button onClick={onClose} className="text-gray-400 hover:text-gray-300">
          <X className="w-4 h-4" />
        </button>
      )}
    </motion.div>
  );
};

export default HeartbeatsGuide;
